<!--
 * @LastEditors: Yx
 * @LastEditTime: 2022-08-04 14:12:58
 * @Description: 
 * @Author: Yx
 * @Date: 2022-07-15 17:04:38
 * @FilePath: \szjzsoft-framework\src\App.vue
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>
